import styled from 'styled-components'
import { styles } from 'lib/ui/components/Form/components/Input/styled'

export const Input = styled.input<{isFormik: boolean}>`
  &.invalid {
    outline-color: ${props => props.theme.palette.state.danger};
  }

  ${({ isFormik, theme }) => isFormik && `
    ${styles}
    border-radius: 5px;

    &.invalid {
      border-color: ${theme.palette.state.danger} !important;
    }
  `}
`

export const Wrapper = styled.div`
  margin-bottom: 5px;

  .form-error {
    position: absolute;
    width: 300px;
  }

  .error-wrapper {
    position: relative;
    margin: 0 0 20px;
    padding: 10px 0;
  }
`
